import React, { useCallback,useState, useEffect } from "react";
import ReactMarkdown from 'react-markdown'
import filterString from '../common3/filterString'


export default (props) => {

  const { extra = {}, builder = false} = props;
  const { content = 'Enter markdown here...' } = extra;

  const filterContent = builder ? content : filterString(content, props)

  return (
    <ReactMarkdown source={filterContent} />
  );
};
